import { r as OcclusionMesh } from "../occlusion-mesh-idwaFwWz.js";
//#region ../src/visualization/occluder-sink.ts
/**
* Build the persistent-occluder resources for one session. The caller
* decides WHETHER; this factory owns HOW, from the mesher style, debug
* style, radius and confidence floor in `options`.
*/
function createOccluderSink(parent, options, deps) {
	const mode = options.meshMode;
	const minConfidence = options.minConfidence;
	const radiusM = options.radiusM;
	const mesh = (deps.createMesh ?? ((p, o) => new OcclusionMesh(p, o)))(parent, { mode });
	mesh.setDebugStyle(options.debugStyle);
	if (options.occlude === false) mesh.setVisible(false);
	const worker = deps.createWorker();
	let disposed = false;
	let epoch = 0;
	return {
		sink: {
			refresh: (g, pose) => {
				if (disposed) return;
				const requestedIn = epoch;
				worker.driver.request(radiusM > 0 && pose && pose.cameraPos.every(Number.isFinite) ? g.getOccupiedCellsWithinFlat([
					pose.cameraPos[0],
					pose.cameraPos[1],
					pose.cameraPos[2]
				], radiusM, minConfidence) : g.getOccupiedCellsFlat(minConfidence), g.cellSizeM, mode, (cell) => g.getCellPoint(cell), (positions, indices) => {
					if (!disposed && requestedIn === epoch) mesh.applyMeshData(positions, indices);
				});
			},
			clear: () => {
				if (!disposed) {
					epoch += 1;
					mesh.clear();
				}
			}
		},
		mesh: () => mesh.getMesh(),
		triangleCount: () => disposed ? 0 : mesh.getTriangleCount(),
		dispose: () => {
			if (disposed) return;
			disposed = true;
			worker.dispose();
			mesh.dispose();
		}
	};
}
//#endregion
export { createOccluderSink };
